import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

// Shared view/edit modal for a single item's Remarks -- used by both the HEAD_OFFICE item
// row (add-item-modal.js) and the SINGLE_STORE item row (single-store-row.js) in place of
// the inline Remarks text field, in both create-PR and edit-PR (edit-pr reuses both rows).
const RemarksDialog = ({ open, initialValue, onClose, onSave, readOnly }) => {
  const [value, setValue] = useState(initialValue || "");

  useEffect(() => {
    if (open) setValue(initialValue || "");
  }, [open, initialValue]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Item Remarks</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          size="small"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          InputProps={{ readOnly }}
          placeholder="Enter remarks for this item"
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{readOnly ? "Close" : "Cancel"}</Button>
        {!readOnly && (
          <Button variant="contained" onClick={() => onSave(value)}>
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default RemarksDialog;
